import React from "react";
import { useNavigate } from "react-router-dom";
import UtilsUnit from "../../../utils/UtilsUnit";
import ConstantsImages from "../../../constants/ConstantsImages";
import WidgetIcon from "../../icons/widget-icon/WidgetIcon";
import WidgetTooltipWrapper from "../widget-tooltip-wrapper/WidgetTooltipWrapper";
import ConstantsTexts from "../../../constants/ConstantsTexts";

const WidgetCreateTerminalIcon = ({ editMode = false, isCreateBlocked = false, onCreateBlocked }) => {
  const navigate = useNavigate();

  const backgroundColor = editMode ? "#696E83" : "#2e2e2e";
  const cursor = editMode ? "default" : "pointer";

  const handleClick = () => {
    if (editMode) {
      return;
    }

    if (isCreateBlocked) {
      onCreateBlocked?.();
      return;
    }

    UtilsUnit.handleCreateTerminalClick(navigate, editMode);
  };

  return (
    <WidgetTooltipWrapper content={ConstantsTexts.CODE_181}>
      <WidgetIcon
        iconProp={ConstantsImages.ADD_IMAGE}
        widthIconProp="1.3rem"
        heightIconProp="1.4rem"
        backgroundColorProp={backgroundColor}
        cursorProp={cursor}
        handleOnClickProp={handleClick}
        customClassNameProp="widget-create-terminal-icon"
        dataHoverDisabled={editMode}
      />
    </WidgetTooltipWrapper>
  );
};

export default WidgetCreateTerminalIcon;
